<template>
  <el-container
    class="container-list is-vertical"
    style="height: 100%; width: 100%; position: fixed;"
  >
    <top-header>
      <template slot="left">
        <!-- <el-input @keyup.enter.native="search" @input="delaySearch" style="width: 240px;" placeholder="搜尋" v-model="keyword" class="input-with-select">
        <el-button @click="search" slot="append" icon="el-icon-search"></el-button>
        </el-input>-->
      </template>
      <template slot="right">
        <!-- <el-button @click="$router.push({ name: 'createFaq' })" style="margin-right: 20px;">新增訊息</el-button> -->
      </template>
    </top-header>
    <el-container>
      <left-menu />

      <el-main v-loading="isLoading">
        <el-table :data="tableData" stripe height="calc(100% - 40px)">
          <template slot="empty">沒有資料</template>
          <el-table-column label="名稱">
            <template slot-scope="scope">{{scope.row.Name}}</template>
          </el-table-column>
          <el-table-column label="Email">
            <template slot-scope="scope">{{scope.row.Email}}</template>
          </el-table-column>
          <el-table-column label="電話">
            <template slot-scope="scope">{{scope.row.Phone}}</template>
          </el-table-column>
          <el-table-column label="時間" width="170px">
            <template slot-scope="scope">{{scope.row.CreatedAt | moment}}</template>
          </el-table-column>
          <el-table-column label="操作" width="120px">
            <template slot-scope="scope">
              <el-button
                size="mini"
                round
                @click="$router.push({ name: 'message', params: { id: scope.row.ID }})"
              >檢視</el-button>
            </template>
          </el-table-column>
        </el-table>

        <el-pagination
          background
          layout="prev, pager, next"
          :currentPage="currentPage"
          :page-size="20"
          :total="searchedObjs.length"
          @current-change="onChangePage"
        ></el-pagination>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import LeftMenu from '@/views/components/LeftMenu.vue'
import TopHeader from '@/views/components/TopHeader.vue'
// svgs
import '@/assets/svgs/index.js'
// mixin
import MixinFilters from '@/utils/filters/filter-mixin.vue'
import MixinDelaySearch from '@/utils/mixin-delaysearch.vue' // filterObjs method required
export default {
  mixins: [MixinFilters, MixinDelaySearch],
  components: {
    LeftMenu,
    TopHeader
  },
  data () {
    return {
      tableData: [],
      currentPage: 1,
      isLoading: false,
      // 篩選
      filteringStatus: null,
      filteringDateRange: null
    }
  },
  computed: {},
  methods: {
    onChangePage (page) {
      this.currentPage = page
      this.tableData = this.searchedObjs.slice((page - 1) * 20, page * 20)
    },
    filterObjs () {
      if (!this.keyword && !this.filteringStatus && !this.filteringDateRange) {
        this.searchedObjs = this.$store.state.message.list
        return
      }

      const isObjFitKeyword = o => {
        if (!this.keyword) return true
        let isFitQuestion = o.Question && o.Question.includes(this.keyword)
        let isFitAnswer = o.Answer && o.Answer.includes(this.keyword)
        return isFitQuestion || isFitAnswer
      }

      const isObjFitStatus = o => {
        if (!this.filteringStatus) return true
        if (this.filteringStatus === '全部') return true
        return o.IsActive === (this.filteringStatus === '已發佈')
      }

      this.searchedObjs = this.$store.state.message.list.filter(u => {
        return isObjFitKeyword(u) && isObjFitStatus(u)
      })
    },
    askToDelete (idx, obj) {
      this.$confirm(`確定刪除此訊息 「${obj.Name}」?`, '刪除確認', {
        confirmButtonText: '確定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.deleteObj(obj)
      })
    },
    deleteObj (obj) {
      this.$services.message.delete(this, obj.ID).then(res => {
        let ok = res && res.data && res.data.status === 'ok'
        if (ok) {
          let idx = this.$store.state.message.list.findIndex(
            o => o.ID === obj.ID
          )
          if (idx >= 0) this.$store.state.message.list.splice(idx, 1)
          this.filterObjs()
          this.tableData = this.searchedObjs.slice(
            (this.currentPage - 1) * 20,
            this.currentPage * 20
          )
          this.$message({
            message: `刪除成功`,
            type: 'success'
          })
        }
      }).catch(this.$handleServiceError)
    }
  },
  created () {
    const initTableData = () => {
      this.searchedObjs = this.$store.state.message.list
      this.tableData = this.searchedObjs.slice(0, 20)
    }
    initTableData()
  }
}
</script>

<style>
.draft {
  color: #666;
  font-weight: 300;
}
.deployed {
  color: #60af4d;
  font-weight: 700;
}
</style>
